module.exports = __webpack_public_path__ + "media/Politica.83fd8ba4.mp3";